/**
 * Helper functions for OutputBuilder component
 */

/**
 * Validates if a string contains only alphanumeric characters and commas
 * @param {string} data - The string to validate
 * @returns {string} - Invalid data if found, empty string otherwise
 */
export const isValidString = (data) => {
	let invalidData = "";
	if (data != null && data !== undefined) {
		const inputValue = data.split(",");

		for (const element of inputValue) {
			const regex = /^[a-zA-Z0-9,]*$/;
			if (!regex.test(element.trim())) {
				invalidData += `${element}, `;
			}
		}
	}

	return invalidData;
};

/**
 * Compare and filter arrays based on properties that have changed
 * @param {Array} arr1 - Current array of objects
 * @param {Array} arr2 - Original array of objects to compare against
 * @param {string} property1 - First property to compare
 * @param {string|null} property2 - Second property to compare, can be null
 * @param {string|null} property3 - Third property to compare, can be null
 * @returns {Array} - Filtered array containing only changed objects
 */
export const compareAndFilter = (
	arr1,
	arr2,
	property1,
	property2,
	property3,
) => {
	return arr1.filter((item1) => {
		const item2 = arr2.find((item2) => item2.id === item1.id);
		if (property1 != null && property2 != null && property3 != null) {
			return (
				item2 &&
				(item2[property1] !== item1[property1] ||
					item2[property2] !== item1[property2] ||
					item1[property2] === "Issue" ||
					item1[property2] === "Non-Issue" ||
					item2[property3] !== item1[property3])
			);
		}
		if (property1 != null && property2 === null && property3 === null) {
			return item2 && item2[property1] !== item1[property1];
		}
	});
};

/**
 * Validate grid data for form submission
 * @param {Object} gridRef - Reference to the AG Grid instance
 * @returns {Object} - Object containing validation results
 */
export const validateGridData = (gridRef, rowData, originalRowData) => {
	let errMsg = "SN - ";
	let isValidFormNo = "Invalid form number entered in - \nSN - ";
	let isError = false;
	let isValidFormNumber = "";
	let editedRowData = [];

	gridRef.current.api.forEachNode((rowNode) => {
		// Validate form number and permanent status are updated together
		if (
			rowNode.data.formNumber !== "" &&
			rowNode.data.formNumber != null &&
			(rowNode.data.permanentStatus === "Select" ||
				rowNode.data.permanentStatus == null)
		) {
			errMsg += `${isError === true ? "," : ""} (${rowNode.rowIndex + 1})`;
			isError = true;
		}

		if (
			(rowNode.data.formNumber === "" || rowNode.data.formNumber == null) &&
			rowNode.data.permanentStatus !== "Select" &&
			rowNode.data.permanentStatus != null
		) {
			errMsg += `${isError === true ? "," : ""} (${rowNode.rowIndex + 1})`;
			isError = true;
		}

		// Validate form number format
		if (rowNode.data.formNumber !== "") {
			let invalidText = "";
			invalidText = isValidString(rowNode.data.formNumber);
			if (invalidText !== "") {
				isValidFormNo += `(${rowNode.rowIndex + 1}) , `;
				isValidFormNumber = isValidFormNo;
			}
		}
	});

	if (isValidFormNumber !== "")
		isValidFormNumber +=
			"\nForm number with special characters and spaces is not allowed.";

	if (!isError) {
		errMsg = "";
		const filteredData = compareAndFilter(
			rowData,
			originalRowData,
			"formNumber",
			"permanentStatus",
			"confirmResult",
		);
		editedRowData = [...filteredData];
	} else {
		errMsg +=
			"\nBoth Form Number and Permanent Status columns has to be \nupdated or kept as it is.";
	}

	return {
		errorMessage: errMsg,
		formNumberError: isValidFormNumber,
		editedRows: editedRowData,
		isValid: errMsg === "" && isValidFormNumber === "",
	};
};
